<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <div>
    <BusinessEntityCannotChangeAlert v-if="!complianceData.canChange" />

    <UkBusinessEntityType
      v-model="businessEntityType"
      class="m-t-10"
      :disabled="!complianceData.canChange"
    />

    <UkBusinessEntityLimitedForm
      v-if="businessEntityType === 'limited'"
      v-model:business-entity="internalBusinessEntity"
      :compliance-data="complianceData"
      :freelancer="freelancer"
    />
    <template v-else-if="businessEntityType === 'sole_trader'">
      <UkBusinessEntitySoleTraderForm
        v-model:business-entity="internalBusinessEntity"
        :compliance-data="complianceData"
        :freelancer="freelancer"
      />
      <UkBusinessEntitySoleTraderAlert class="m-t-10" />
    </template>
    <UkBusinessEntityUmbrellaForm
      v-else-if="businessEntityType === 'umbrella'"
      v-model:business-entity="internalBusinessEntity"
      :compliance-data="complianceData"
      :freelancer="freelancer"
    />
    <UkBusinessEntityNoSetupAlert v-else-if="businessEntityType === 'no_setup'" />

    <fieldset>
      <legend>
        {{ $t("What's your PAYE preference?") }}
      </legend>
      <UkPayePreference
        v-if="complianceData.canPaymentScheme"
        v-model="canPaye"
        :business-entity="internalBusinessEntity"
      />
    </fieldset>

    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <SubmitButton class="m-t-20" :text="$t('Save')" auto-submit></SubmitButton>
  </div>
</template>

<script>
/* eslint-disable import-x/extensions */
import BusinessEntityCannotChangeAlert from '@/components/compliances/BusinessEntity/BusinessEntityCannotChangeAlert.vue'
import UkBusinessEntityLimitedForm from '@/components/compliances/BusinessEntity/Uk/UkBusinessEntityLimitedForm.vue'
import UkBusinessEntityNoSetupAlert from '@/components/compliances/BusinessEntity/Uk/UkBusinessEntityNoSetupAlert.vue'
import UkBusinessEntitySoleTraderAlert from '@/components/compliances/BusinessEntity/Uk/UkBusinessEntitySoleTraderAlert.vue'
import UkBusinessEntitySoleTraderForm from '@/components/compliances/BusinessEntity/Uk/UkBusinessEntitySoleTraderForm.vue'
import UkBusinessEntityType from '@/components/compliances/BusinessEntity/Uk/UkBusinessEntityType.vue'
import UkBusinessEntityUmbrellaForm from '@/components/compliances/BusinessEntity/Uk/UkBusinessEntityUmbrellaForm.vue'
import UkPayePreference from '@/components/compliances/BusinessEntity/Uk/UkPayePreference.vue'
import { deepClone, setdefault } from '@/utils/tools'

export default {
  name: 'FreelancerUkBusinessEntityForm',
  components: {
    BusinessEntityCannotChangeAlert,
    UkBusinessEntityLimitedForm,
    UkBusinessEntityNoSetupAlert,
    UkBusinessEntitySoleTraderAlert,
    UkBusinessEntitySoleTraderForm,
    UkBusinessEntityType,
    UkBusinessEntityUmbrellaForm,
    UkPayePreference,
  },
  props: {
    businessEntity: {
      type: Object,
      required: true,
    },
    complianceData: {
      type: Object,
      required: true,
    },
    freelancer: {
      type: Object,
      required: true,
    },
  },
  data() {
    const internalBusinessEntity = deepClone(this.businessEntity)

    return {
      internalBusinessEntity,
    }
  },
  computed: {
    businessEntityType: {
      get() {
        return this.internalBusinessEntity.entityType
      },
      set(businessEntityType) {
        this.internalBusinessEntity.entityType = businessEntityType
        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },
    canPaye: {
      get() {
        return (
          // For some reason we save this specific value in 2 different styles and potentially more
          this.internalBusinessEntity.data?.can_paye === '1' ||
          this.internalBusinessEntity.data?.can_paye === true ||
          this.internalBusinessEntity.data?.can_paye === 'true'
        )
      },
      set(canPaye) {
        const data = setdefault(this.internalBusinessEntity, 'data', {})
        data.can_paye = canPaye ? '1' : null
        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },
  },
}
</script>
